import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'navbar',
      component: resolve => require(['@/views/navbar'], resolve),
      redirect: {
        path: 'home'
      },
      children: [
        {
          path: 'home',
          name: 'home',
          component: resolve => require(['@/views/index/home'], resolve)
        },
        {
          path: 'aboutUs',
          name: 'aboutUs',
          component: resolve => require(['@/views/aboutUs/aboutUs'], resolve)
        },
        {
          path: 'news',
          name: 'news',
          component: resolve => require(['@/views/aboutUs/news'], resolve)
        },
        {
          path: 'newsInfo',
          name: 'newsInfo',
          component: resolve => require(['@/views/aboutUs/newsInfo'], resolve)
        },
        {
          path: 'developHis',
          name: 'developHis',
          component: resolve => require(['@/views/aboutUs/developHis'], resolve)
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js